import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#E27423",
      d: "M9.003 15c-.12-.875-.267-1.74-.46-2.598C8.177 10.775 7.188 9.82 5.59 9.46a28 28 0 0 0-2.25-.413L3 8.993c.883-.13 1.678-.274 2.47-.433 1.784-.36 2.795-1.455 3.14-3.235.15-.77.293-1.54.422-2.325l.112.751c.093.625.221 1.242.36 1.86.36 1.598 1.336 2.545 2.908 2.907.844.195 1.696.34 2.588.467-.698.122-1.36.23-2.02.357-.677.132-1.338.32-1.939.678-.869.518-1.266 1.358-1.517 2.293-.224.832-.354 1.683-.467 2.537-.006.05.018.114-.054.15M3 5.333C4.132 5.297 4.7 4.73 4.724 3.6c.336 1.412.42 1.496 1.756 1.746-1.096.038-1.705.563-1.731 1.732C4.699 5.94 4.135 5.365 3 5.333M11.52 12.654c1.132-.036 1.7-.604 1.725-1.734.335 1.413.42 1.497 1.755 1.747-1.096.038-1.705.563-1.731 1.733-.05-1.139-.614-1.714-1.749-1.746"
    }, null, -1)
  ]))]))
}
export default { render: render }